<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
           <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>Export Unmatched Accounts</h5>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>

      <!-- AgGrid Table -->
      <DataGrid :context="'remainingUnmatchedAccountsGrid'" 
        ref="remainingUnmatchedAccountsGrid"
        :columnDefs="columnDefs"
        :rowData="remainingUnmatchedAccount"
        :dataSource="dataSource"
      >
      </DataGrid>
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  data: () => ({
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    remainingUnmatchedAccount: [],
    columnDefs: [
    ]
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  watch: {
  },
  methods: {
        goBack: function() {
          this.$router.go(-1);
    },

    getColumnsFromCSVTable() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          self.$route.params.campaignId
        )
        .then(res => {
          if (res.data.status == "success") {
              let selected_columns = res.data.data;



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              selected_columns.forEach(function(ele) {

            
                ele.headerName = ele.name;

                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


                  if (ele.type == "date") {
                    ele.filter = "agDateColumnFilter";
                  } else if (ele.type == "number") {
                    ele.filter = "agNumberColumnFilter";
                  } else {
                    ele.filter = "agTextColumnFilter";
                  }



                ele.width = 170;
                ele.filterParams = {
                  buttons: ["apply", "reset"],
                  maxNumConditions: 4
                };
              });


            self.columnDefs = selected_columns

          
          }

        

        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          const campaignId = self.$route.params.campaignId;

          params.request.table_name = 'temp_' + campaignId.replaceAll("-", "_") + "_accounts";

          self.$store
                .dispatch(
                  "accountsManagement/remainingUnmatchedAccount",
                  params.request
                )
                .then(function(response) {
                  let response_data = response.rows;

                   console.log("REmaina" , response_data);


                  if (response_data.length != 0) {
                    self.$refs.remainingUnmatchedAccountsGrid.gridApi.hideOverlay();

                    params.success({ rowData: response.rows , rowCount: response.lastRow })
                  } else {
                    self.$refs.remainingUnmatchedAccountsGrid.gridApi.showNoRowsOverlay();
                    return params.success({ rowData: [] })
                  }
                })
                // .then(response =>
                //   params.successCallback(response.rows, response.lastRow)
                // )
                .catch(err => {
                  console.error(err);
                });
        }
      };
    }
  },
  mounted() {
    this.getDataSource();
    this.getColumnsFromCSVTable();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
